import config from '@/config'
import timelineConfig from '@/components/views/Campaign/Timeline/config'
// import moment from 'moment';
import utils from '@/utils'
import orderBy from 'lodash/orderBy';
import apiService from '../../services/apiService'
const campaignServiceBaseURL = config.apiServiceBaseURL.campaign // use of campaign service base url
const state = {
  // Campaign Timeline
  timelines: [],
  savedTimeline: false,
  timelineDetail: {},
  timelineSummary: [],
  actualDays: null,
  timelineStages: {
    activating: 'activating',
    pairing: 'pairing',
    cocreating: 'cocreating',
    complete: 'complete'
  },
  // Review Meetings
  reviewMeetings: [],
  savedReviewMeeting: false,
  reviewMeetingDetail: {}
}

const actions = {
  /**
   * get campaign timeline detail by id
   * @param {*} commit
   * @param {*} id
   * @returns
  */
  async getCampaignTimeline ({ commit }, id) {
    try {
      commit('SET_DATA', {
        name: 'timelineDetail',
        data: {}
      })
      let response = await apiService.get(campaignServiceBaseURL + `/timeline?campaignID=${id}`)
      let timelineDetail = {}
      if (Array.isArray(response) && response.length) {
        const campaign = response.find(item => String(item.id) === String(id)) || response[0]
        const timelines = campaign && Array.isArray(campaign.timelines) ? campaign.timelines : []
        timelineDetail = timelines.find(item => String(item.campaignID) === String(id)) || timelines[0] || {}
      }
      commit('SET_DATA', {
        name: 'timelineDetail',
        data: timelineDetail
      })
      return timelineDetail
    } catch (err) {
      console.error(err)
      return null
    }
  },
  /**
   * get campaign timelines
   * @param {*} commit
   * @returns
  */
  async getCampaignTimelineLists ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'timelines',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(campaignServiceBaseURL + `/timeline?${params}`)
      if (Array.isArray(response) && response.length) {
        commit('SET_DATA', {
          name: 'timelines',
          data: response
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get campaign timeline summary
   * @param {*} commit
   * @returns
  */
  async getCampaignTimelineSummary ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'timelineSummary',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(campaignServiceBaseURL + `/timeline/summary?${params}`)
      if (Array.isArray(response) && response.length) {
        commit('SET_DATA', {
          name: 'timelineSummary',
          data: response
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get campaign timeline summary actual days
   * @param {*} commit
   * @returns
  */
  async getActualDays ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'actualDays',
        data: null
      })
      if (!payload.campaignID || !payload.type) {
        return false
      }
      let response = await apiService.get(campaignServiceBaseURL + `/timeline/actual-days/${payload.campaignID}/${payload.type}`)
      if (response) {
        commit('SET_DATA', {
          name: 'actualDays',
          data: response
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save campaign timeline table data
   */
  async saveTimeline({ commit }, formData) {
    try {
      commit('SET_DATA', {
        name: 'savedTimeline',
        data: false
      })
      await apiService.post(campaignServiceBaseURL + '/timeline/create', formData)
      commit('SET_DATA', {
        name: 'savedTimeline',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get review meetings lists with optional filters
   * @param {*} commit
   * @returns
  */
  async getReviewMeetingLists ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'reviewMeetings',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(campaignServiceBaseURL + `/review-meeting?${params}`)
      if (Array.isArray(response) && response.length) {
        commit('SET_DATA', {
          name: 'reviewMeetings',
          data: response
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get campaign review meeting detail by id
   * @param {*} commit
   * @param {*} id
   * @returns
  */
  async getReviewMeeting ({ commit }, id) {
    try {
      commit('SET_DATA', {
        name: 'reviewMeetingDetail',
        data: {}
      })
      let response = await apiService.get(campaignServiceBaseURL + `/review-meeting?campaignID=${id}`)
      if (Array.isArray(response) && response.length) {
        commit('SET_DATA', {
          name: 'reviewMeetingDetail',
          data: response[0].reviewmeetings.length ? response[0].reviewmeetings[0] : {}
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save review meetings table data
  */
  async saveReviewMeeting({ commit }, formData) {
    try {
      commit('SET_DATA', {
        name: 'savedReviewMeeting',
        data: false
      })
      await apiService.post(campaignServiceBaseURL + '/review-meeting/create', formData)
      commit('SET_DATA', {
        name: 'savedReviewMeeting',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save review deck url
  */
  async saveReviewDeck({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'savedReviewDeck',
        data: false
      })
      await apiService.post(campaignServiceBaseURL + '/review-meeting/update/review-deck', payload)
      commit('SET_DATA', {
        name: 'savedReviewDeck',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  }
}

const getters = {
  /**
  * - (a) Date where client accept campaign brief to first payout confirmed
  * - (b) First Payout to ALL payouts confirmed
  */
  getActivatingDays: (state, getters) => (campaignVal) => {
    // The date they campaign (created) => the date when client accepted
    let results = {
      briefing: {
        days: null,
        startDate: null,
        endDate: null
      }
    }
    let campaignActivity = campaignVal.activity || {}
    let createdAt = utils.func.formatCustomDate(campaignVal.createdAt, 'YYYY-MM-DD')
    let clientAcceptedAt = campaignActivity.clientApproveAt ? utils.func.formatCustomDate(campaignActivity.clientApproveAt, 'YYYY-MM-DD') : null
    if (createdAt && clientAcceptedAt) {
      results.briefing.days = utils.func.dayDurations(createdAt, clientAcceptedAt)
    }
    if (createdAt) results.briefing.startDate = utils.func.formatCustomDate(createdAt, 'DD/MM/YYYY')
    if (clientAcceptedAt) results.briefing.endDate = utils.func.formatCustomDate(clientAcceptedAt, 'DD/MM/YYYY')
    return results
  },
  /**
  * - (a) Date where client accept campaign brief to first payout confirmed
  * - (b) First Payout to ALL payouts confirmed
  */
  getPairingDays: (state) => (campaignVal) => {
    let results = {
      firstPayoutConfirmed: {
        days: null,
        startDate: null,
        endDate: null
      },
      allPayoutConfirmed: {
        days: null,
        startDate: null,
        endDate: null
      }
    }
    let campaignActivity = campaignVal.activity || {}
    let clientAcceptedAt = campaignActivity.clientApproveAt ? utils.func.formatCustomDate(campaignActivity.clientApproveAt, 'YYYY-MM-DD') : null
    if (clientAcceptedAt) results.firstPayoutConfirmed.startDate = utils.func.formatCustomDate(clientAcceptedAt, 'DD/MM/YYYY')
    if (state.timelineDetail.payoutConfirmHistory && state.timelineDetail.payoutConfirmHistory.length) {
      let confirmedHistories = state.timelineDetail.payoutConfirmHistory
      let firstPayoutConfirmedDate = confirmedHistories[0].created_at
      let lastPayoutConfirmedDate = confirmedHistories[confirmedHistories.length - 1].created_at
      if (clientAcceptedAt && firstPayoutConfirmedDate) {
        results.firstPayoutConfirmed.days = utils.func.dayDurations(clientAcceptedAt, firstPayoutConfirmedDate)
      }
      if (firstPayoutConfirmedDate) {
        results.firstPayoutConfirmed.endDate = utils.func.formatCustomDate(lastPayoutConfirmedDate, 'DD/MM/YYYY')
        results.allPayoutConfirmed.startDate = utils.func.formatCustomDate(firstPayoutConfirmedDate, 'DD/MM/YYYY')
      }
      if (firstPayoutConfirmedDate && lastPayoutConfirmedDate) {
        results.allPayoutConfirmed.days = utils.func.dayDurations(firstPayoutConfirmedDate, lastPayoutConfirmedDate)
      }
      if (lastPayoutConfirmedDate) {
        results.allPayoutConfirmed.endDate = utils.func.formatCustomDate(lastPayoutConfirmedDate, 'DD/MM/YYYY')
      }
    }
    return results
  },
  /**
   * - (a) Date of CC confirm payout on invoice & brief => date of 1st content submitted on IMS
   * - (b) date of submitted on IMS => liveDate of the first content which is presented on the campaign report
   * - (c) first live date in Report => last live Date
   */
  getCocreatingDays: (state) => async (posts, reports) => {
    // resp results
    let results = {
      firstContentSubmitted: {
        days: null,
        startDate: null,
        endDate: null
      },
      firstReportLive: {
        days: null,
        startDate: null,
        endDate: null
      },
      lastReportLive: {
        days: null,
        startDate: null,
        endDate: null
      }
    }
    // define vars for calc
    let lastPayoutConfirmedDate = null
    let firstContentSubmittedDate = null
    let firstRptLiveDate = null
    let lastRptLiveDate = null
    // get last payout confirmed date
    if (state.timelineDetail.payoutConfirmHistory && state.timelineDetail.payoutConfirmHistory.length) {
      let confirmedHistories = state.timelineDetail.payoutConfirmHistory
      lastPayoutConfirmedDate = confirmedHistories[confirmedHistories.length - 1].created_at
    }
    // calc firstContentSubmittedDays
    let createdDates = posts.map(p => {
      if (p.createdAt) {
        return {'date': utils.func.formatCustomDate(p.createdAt, 'YYYY-MM-DD')}
      } else return ''
    }).filter(p => p)
    if (createdDates.length) {
      createdDates = orderBy(createdDates, ['date'], ['asc'])
      firstContentSubmittedDate = createdDates[0].date
    }
    if (lastPayoutConfirmedDate && firstContentSubmittedDate) {
      results.firstContentSubmitted.days = utils.func.dayDurations(lastPayoutConfirmedDate, firstContentSubmittedDate)
    }
    if (lastPayoutConfirmedDate) results.firstContentSubmitted.startDate = utils.func.formatCustomDate(lastPayoutConfirmedDate, 'DD/MM/YYYY')
    if (firstContentSubmittedDate) {
      results.firstContentSubmitted.endDate = utils.func.formatCustomDate(firstContentSubmittedDate, 'DD/MM/YYYY')
      results.firstReportLive.startDate = utils.func.formatCustomDate(firstContentSubmittedDate, 'DD/MM/YYYY')
    }
    // calc firstReportLiveDays && lastReportLiveDays
    let liveDates = reports.map(rpt => {
      if (rpt.live_date) {
        return {'date': utils.func.formatCustomDate(rpt.live_date, 'YYYY-MM-DD')}
      } else return ''
    }).filter(rpt => rpt)
    if (liveDates.length) {
      liveDates = orderBy(liveDates, ['date'], ['asc'])
      firstRptLiveDate = liveDates[0].date
      lastRptLiveDate = liveDates[liveDates.length - 1].date
    }
    if (firstContentSubmittedDate && firstRptLiveDate) {
      results.firstReportLive.days = utils.func.dayDurations(firstContentSubmittedDate, firstRptLiveDate)
    }
    if (firstRptLiveDate) {
      results.firstReportLive.endDate = utils.func.formatCustomDate(firstRptLiveDate, 'DD/MM/YYYY')
      results.lastReportLive.startDate = utils.func.formatCustomDate(firstRptLiveDate, 'DD/MM/YYYY')
    }
    if (firstRptLiveDate && lastRptLiveDate) {
      results.lastReportLive.days = utils.func.dayDurations(firstRptLiveDate, lastRptLiveDate)
    }
    if (lastRptLiveDate) {
      results.lastReportLive.endDate = utils.func.formatCustomDate(lastRptLiveDate, 'DD/MM/YYYY')
    }
    return results
  },
  /**
   * date of last content live date to date of review date entered
   * @param {*} state
   * @param {Array} reports
   * @returns
   */
  getCompleteDays: (state) => async (reports) => {
    let result = {
      reviewDate: {
        days: null,
        startDate: null,
        endDate: null
      }
    }
    let lastRptLiveDate = null
    let reviewMeetingDate = null
    // calc firstReportLiveDays && lastReportLiveDays
    let liveDates = reports.map(rpt => {
      if (rpt.live_date) {
        return {'date': utils.func.formatCustomDate(rpt.live_date, 'YYYY-MM-DD')}
      } else return ''
    }).filter(rpt => rpt)
    if (liveDates.length) {
      liveDates = orderBy(liveDates, ['date'], ['asc'])
      lastRptLiveDate = liveDates[liveDates.length - 1].date
    }
    if (state.reviewMeetingDetail.reviewMeetingDate) {
      reviewMeetingDate = utils.func.parseDate(state.reviewMeetingDetail.reviewMeetingDate)
    }
    if (lastRptLiveDate && reviewMeetingDate) {
      result.reviewDate.days = utils.func.dayDurations(lastRptLiveDate, reviewMeetingDate)
    }
    if (lastRptLiveDate) result.reviewDate.startDate = utils.func.formatCustomDate(lastRptLiveDate, 'DD/MM/YYYY')
    if (reviewMeetingDate) result.reviewDate.endDate = utils.func.formatCustomDate(reviewMeetingDate, 'DD/MM/YYYY')
    return result
  },
  /**
   * This will get number of days for each stage between highest to lowest dates
   * @param {*} state
   * @param {Array} filteredItems
   * @returns
   */
  getStageDays: (state) => (filteredItems) => {
    const stageDays = timelineConfig.timelineTypeLists.map(t => {
      let dates = []
      let filteredItemTypes = filteredItems.filter(f => f.actionType === t.value)
      filteredItemTypes.map(t => {
        // convert date to actual format to calc in day durations
        if (t.startDate) dates.push({'date': utils.func.parseDate(t.startDate)})
        if (t.endDate) dates.push({'date': utils.func.parseDate(t.endDate)})
      })
      if (dates.length) {
        dates = orderBy(dates, ['date'], ['asc'])
        t.days = utils.func.dayDurations(dates[0].date, dates[dates.length - 1].date)
      }
      return t
    })
    return stageDays
  },
  /**
   * this will get actual date values for display in activating stage
   * @param {*} state
   * @param {Object} dateRets
   * @returns
  */
  getActivatingActualDays: (state) => (summary, dateRets) => {
    let activatingDaysDisplay = {
      briefingDays: dateRets.days,
      briefingStartDate: dateRets.briefing.startDate,
      briefingEndDate: dateRets.briefing.endDate
    }
    summary.actual = activatingDaysDisplay.briefingDays ? `${activatingDaysDisplay.briefingDays} days` : 'invalid'
    summary.actualTasks[0].value = activatingDaysDisplay.briefingStartDate ? `${activatingDaysDisplay.briefingStartDate}` : 'invalid'
    summary.actualTasks[1].value = activatingDaysDisplay.briefingEndDate ? `${activatingDaysDisplay.briefingEndDate}` : 'invalid'
    return summary
  },
  /**
   * this will get actual date values for display in pairing stage
   * @param {*} state
   * @param {Object} dateRets
   * @returns
  */
  getPairingActualDays: (state) => (summary, dateRets) => {
    /* eslint-disable */
    summary.actual = dateRets.days ? `${dateRets.days} days` : 'invalid'
    let idx = 0
    let pairingDaysDisplay = {
      firstPayoutConfirmedStartDate: dateRets.firstPayoutConfirmed.startDate, // brief accepted at
      allPayoutConfirmedStartDate: dateRets.allPayoutConfirmed.startDate, // first payout confirmed date
      allPayoutConfirmedEndDate: dateRets.allPayoutConfirmed.endDate // all payout confirmed date
    }
    for (const [key, value] of Object.entries(pairingDaysDisplay)) {
      summary.actualTasks[idx].value = value || value === 0 ? `${value}` : 'invalid'
      idx += 1
    }
    return summary
  },
  /**
   * this will get actual date values for display in cocreating stage
   * @param {*} state
   * @param {Object} dateRets
   * @returns
  */
  getCocreatingActualDays: (state) => (summary, dateRets) => {
    /* eslint-disable */
    summary.actual = dateRets.days ? `${dateRets.days} days` : 'invalid'
    let idx = 0
    let cocreatingDaysDisplay = {
      // executing days
      firstContentSubmittedStartDate: dateRets.firstContentSubmitted.startDate,
      // submitting days
      firstReportLiveStartDate: dateRets.firstReportLive.startDate,
      // live days
      lastReportLiveStartDate: dateRets.lastReportLive.startDate,
      lastReportLiveEndDate: dateRets.lastReportLive.endDate,
    }
    for (const [key, value] of Object.entries(cocreatingDaysDisplay)) {
      summary.actualTasks[idx].value = value || value === 0 ? `${value}` : 'invalid'
      idx += 1
    }
    return summary
  },
  /**
   * this will get actual date values for display in complete stage
   * @param {*} state
   * @param {Object} dateRets
   * @returns
  */
  getCompleteActualDays: (state) => (summary, dateRets) => {
    /* eslint-disable */
    summary.actual = dateRets.days ? `${dateRets.days} days` : 'invalid'
    let idx = 0
    let completeDaysDisplay = {
      // executing days
      reviewDateStartDate: dateRets.reviewDate.startDate,
      reviewDateEndDate: dateRets.reviewDate.endDate
    }
    for (const [key, value] of Object.entries(completeDaysDisplay)) {
      summary.actualTasks[idx].value = value || value === 0 ? `${value}` : 'invalid'
      idx += 1
    }
    return summary
  },
  /**
   * get projected days for each stage
   * @param {*} state
   * @returns
   */
  getProjectedDaysByStage: (state) => (stageVal) => {
    if (state.timelineDetail.numberOfDaysPerStage) {
      let matchStage = state.timelineDetail.numberOfDaysPerStage.filter(s => s.value === stageVal)
      if (matchStage.length) return matchStage[0].days
    }
    return null
  },
  /**
   * calc different review meeting dates based on review meeting date
   * @param {*} state
   * @param {date} reviewDate YYYY-MM-DD
   * @param {Array} reports
   * @returns
   */
  getReviewDates: (state) => (reviewDate, reports) => {
    let result = {
      reviewMeetingDate: '',
      overallAlignmentDate: '',
      amDeckReadyDate: '',
      ccDeckReadyDate: '',
      statsReadyByLivePostsDate: '',
      statsReadyByReviewMeetingDate: ''
    }
    if (!reviewDate) return result
    result.reviewMeetingDate = utils.func.formatCustomDate(reviewDate, 'DD/MM/YYYY')
    result.overallAlignmentDate = utils.func.reduceDays(reviewDate, 2, 'DD/MM/YYYY')
    result.amDeckReadyDate = utils.func.reduceDays(reviewDate, 3, 'DD/MM/YYYY')
    result.ccDeckReadyDate = utils.func.reduceDays(reviewDate, 5, 'DD/MM/YYYY')
    result.statsReadyByReviewMeetingDate = utils.func.reduceDays(reviewDate, 7, 'DD/MM/YYYY')
    // date of latest post live date + 5 days
    let lastRptLiveDate = null
    // calc lastReportLiveDate
    let liveDates = reports.map(rpt => {
      if (rpt.live_date) {
        return {'date': utils.func.formatCustomDate(rpt.live_date, 'YYYY-MM-DD')}
      } else return ''
    }).filter(rpt => rpt)
    if (liveDates.length) {
      liveDates = orderBy(liveDates, ['date'], ['asc'])
      lastRptLiveDate = liveDates[liveDates.length - 1].date
    }
    if (lastRptLiveDate) {
      result.statsReadyByLivePostsDate = utils.func.addDays(lastRptLiveDate, 5, 'DD/MM/YYYY')
    }
    return result
  }
}

/**
 * Need actions to implement
 */
// const actions = {}

const mutations = {
  SET_DATA(state, { name, data }) {
    state[name] = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/campaign/timeline.js